<template>
  <div class="search-container" style="opacity: 1;">
    <div :class="[searchModeal||headSearchModel?'show':'hide']">
      <div
        class="dialog"
        :style="{top:searchDialogMarginTop+'px'}"
        v-if="searchModeal||headSearchModel"
        @click="cancelClick"
        @touchmove.stop.prevent="moveHandle"
      >
        <div
          @click.stop
          :style="{'height':dialogHeight+'rem'}"
          class="dialog-container"
          :class="{'dialog-container-in-searching':inSearchingProducts}"
        >
          <Input
            @on-enter="searchKeyEnter(1)"
            @on-change="searchKeyInput"
            v-model="searchingString"
            type="text"
            placeholder="请输入搜索条件"
            class="search-input"
          />
          <div class="iconenter" @click="searchKeyEnter(1)">
            <img src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202311/54fe1c89c60e9f6e05054df51e8d49b5.png"/>
          </div>

          <div v-show="!inSearching" class="recommend-search">
            <div class="recommend-search-title">推荐搜索</div>
            <ul class="search-list">
              <li
                @click="searchByKeyword(item)"
                v-for="(item, index) in recommendList"
                :key="index"
                class="search-item"
              >
                <a class tabindex="0">{{item.searchKey}}</a>
              </li>
            </ul>
          </div>

          <div v-show="inSearching" class="search-result-content-box">
            <div v-if="inSearchingProducts && genderFilterList.length > 0" class="search-result-check-box">
              <div
                @click="checkGender(item)"
                class="my-check-box"
                v-for="(item, index) in genderFilterList"
                :key="index"
              >
                <div class="check-box-action-box">
                  <img
                    v-if="genderSelectedList[item.recommendationTag]"
                    src="../../assets/image/icon/close.svg"
                  />
                </div>
                <span class="checkbox-title">{{item.text}}</span>
              </div>
              <div @click="clearAllCheckedGender" class="clear-all">清除全部</div>
            </div>

            <div v-if="inSearchingProducts" class="in-searching-product">
              <div class="search-result-content-number-box">
                <div
                  class="search-result-content-number-title"
                >找到{{totalSearchNumber}}款匹配“{{this.searchingString}}”的作品</div>
                <div @click="showAllSearchingProducts" class="search-result-content-number-all">查看全部</div>
              </div>

              <div class="search-result-content">
                <div
                  @click="goPDP(item.friendlyUrl,item,index)"
                  :class="['search-result-content-item',item.imgLoaded ? 'imgloaded':'']"
                  v-for="(item,index) in searchingProductList"
                  :key="index"
                >
                  <img :src="item.imageList[0].originalUrl" class="cover-image" />
                  <div class="result-title">{{item.name}}</div>
                </div>
              </div>
            </div>

            <div v-if="inSearchingKeyWord" class="in-searching-keyword">
              <li
                @click="searchByKeyword(item)"
                class="search-result-keyword-box"
                style="list-style: none"
                v-for="(item,index) in searchingKeyWordList"
                :key="index"
              >
                <a tabindex="0">
                  <div
                    v-html="getHighLineText(item.name)"
                    class="search-result-keyword-title"
                  >{{item.name}}</div>
                </a>
                <div class="search-result-keyword-number">{{item.count}}</div>
              </li>
            </div>
          </div>
        </div>
      </div>

      <div :class="['dialog-mb',(headSearchModel)?'headSearchShow':'']" v-if="searchModeal||headSearchModel" @touchmove.stop.prevent="moveHandle">
        
        <div class="search-container-mp">
          <div class="search-input-box">
            <img
              @click="searchByKeyword({searchKey:searchingString})"
              class="search-image-icon"
              src="../../assets/image/icon/mb-search.svg"
            />
            <Input
              @on-enter="mobileKeyDown"
              style="text-align: center;"
              v-model="searchingString"
              v-on:input="searchKeyInput"
              type="text"
              class="input-content"
              placeholder="请输入搜索条件"
            />
            <img
              @click="searchingString =''"
              class="search-cancel-icon"
              src="../../assets/image/icon/search_cancel_mb.png"
            />
          </div>
          <div class="check-box-mb">
            <div
              @click="checkGender(item)"
              class="my-check-box"
              v-for="(item, index) in genderFilterList"
            >
              <div class="check-box-action-box">
                <img v-if="!genderSelectedList[item.value]" src="../../assets/image/icon/close.svg" />
              </div>
              <span class="checkbox-title">{{item.name}}</span>
            </div>
          </div>
          <div class="search-keyword-content-box-mb" v-show="inSearching">
            <div
              v-html="getHighLineTextMb(item.name)"
              @click="searchByKeyword(item)"
              class="search-keyword-content-item"
              v-for="(item, index) in searchingKeyWordList"
            ></div>
          </div>
        </div>
        <div class="recommend-search-mob" v-show="!inSearching">
      
           <div class="recommend-search-label">推荐搜索</div>
           <ul class="search-list">
              <li
                @click="searchByKeyword(item)"
                v-for="(item, index) in recommendList"
                :key="index"
                class="search-item"
              >
                <a class tabindex="0" v-if="index<10">{{item.searchKey}}</a>
              </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gaAction from "../../utils/gaType";

export default {
  name: "Search",
  data() {
    return {
      inSearching: false,
      inSearchingKeyWord: false,
      inSearchingProducts: false,
      recommendList: [],
      searchingString: "",
      searchingKeyWordList: [],
      searchingProductList: [],
      tagList:[],
      dialogHeight: 30.3,
      genderFilterList: [
        // { name: "男士", value: "MAN" },
        // { name: "女士", value: "LADY" },
        // { name: "儿童", value: "CHILD" }
      ],
      genderSelectedList: {  },
      searchingResultNumber: 0,
      totalSearchNumber:0,
    };
  },
  props: {
    searchModeal: {
      type: Boolean,
      default: false
    },
    headSearchModel:{
      type: Boolean,
      default: false
    },
    searchOptionList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    searchDialogMarginTop: {
      type: Number,
      default: 0
    }
  },
  watch: {
    async searchModeal(newVal) {
      if (newVal) {
        if (!this.recommendList || this.recommendList.length == 0) {
          await this.getRecommendSearchingList();
        }
       
        this.setDialogHeightByKeywordItemNumber(this.recommendList);
      }
    },
    headSearchModel(newVal){
     console.log(newVal,'serachppio')
    }
  },
  components: {},
  async mounted() {
    await this.getRecommendSearchingList();
    
   
  },
  destroyed() {},
  methods: {
    reLoadImage() {
      this.ossSuffix = this.$store.state.ossSuffix;
      for (var i = 0; i < this.searchingProductList.length; i++) {
        var img = new Image();
        //检测是否支持webp格式
        var imgsec = this.searchingProductList[i].imageList[0].originalUrl;
        let flag = this.$utils.checkIsUpdatetoWebp(this, imgsec);
        if (flag) {
          img.src =
            this.searchingProductList[i].imageList[0].originalUrl +
            this.ossSuffix;
        } else {
          img.src = this.searchingProductList[i].imageList[0].originalUrl;
        }
      }
    },
    loadImages(i) {
      // console.log("loadImages: ",i);
      var that = this;
      var img = new Image();

      img.onload = function() {
        // console.log("onload: " + i, "time: " + new Date(), "i shi:", 'id:',that.searchingProductList[i].id);
        //检测是否支持webp格式
        //  console.log("onload: ",i);
        let imgsec = that.searchingProductList[i].imageList[0].originalUrl;
        let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec);
        if (flag) {
          var imageList = that.searchingProductList[i].imageList;
          imageList[0].originalUrl = imageList[0].originalUrl + that.ossSuffix;
          that.$set(that.searchingProductList[i], `imageList`, imageList);
        }
        that.$set(that.searchingProductList[i], `imgLoaded`, true);
        let count = i + 1;
        if (count < that.searchingProductList.length) {
          that.loadImages(count);
        }
      };
      img.onerror = function() {
        that.$set(that.searchingProductList[i], `imgLoaded`, true);
        if (i == 0) {
          that.$emit("loadingFun");
        }
        let count = i + 1;
        if (count < that.searchingProductList.length) {
          that.loadImages(count);
        }
      };
      let flag = that.$utils.checkIsUpdatetoWebp(
        this,
        that.searchingProductList[i].imageList[0].originalUrl
      );
      if (flag) {
        img.src =
          that.searchingProductList[i].imageList[0].originalUrl +
          this.ossSuffix;
      } else {
        img.src = that.searchingProductList[i].imageList[0].originalUrl;
      }
    },
    mobileKeyDown(event) {
   
       this.hasLogin = window.localStorage.getItem("token") ? false : true;
        if(!this.hasLogin){
          this.$utils.searchLogAdd(this,this.searchingString)
        }else{
          this.$utils.searchLogAdd(this,this.searchingString,1)
        }
      this.showAllSearchingProducts();
    },
    getHighLineText(textString) {
      if (textString.indexOf(this.searchingString) !== -1) {
        //判断这个字段中是否包含keyword
        //如果包含的话，就把这个字段中的那一部分进行替换成html字符
        return textString.replace(
          new RegExp(this.searchingString, "g"),
          `<span style='color: #5C5D5F;font-weight: 600;'>${this.searchingString}</span>`
        );
      } else {
        return textString;
      }
    },
    getHighLineTextMb(textString) {
      if (textString.indexOf(this.searchingString) !== -1) {
        //判断这个字段中是否包含keyword
        //如果包含的话，就把这个字段中的那一部分进行替换成html字符
        return textString.replace(
          new RegExp(this.searchingString, "g"),
          `<span style='color: white;font-weight: 600;'>${this.searchingString}</span>`
        );
      } else {
        return textString;
      }
    },
    showAllSearchingProducts() {
      this.$router.push({
        name: "searchList",
        params: { friendly_url: this.searchingString.toUpperCase() }
      });
      this.cancelClick();
      this.clearAllCurrentData();
    },
    goPDP(id, good, index) {
      this.$router.push({
        name: "shopping",
        params: {
          friendly_url: id
        }
      });
      this.gaSelectContent(good, index);
      this.cancelClick();
      this.clearAllCurrentData();
    },

    //GA select_content埋点
    gaSelectContent(good, index) {
      this.$set(good, "list_name", "search_fw");
      this.$set(good, "list_position", index);
      this.$gaAction.select_content(good);
    },

    async getRecommendSearchingList() {
      let result = await this.$service.searching.getRecommendSearchingList();
      if (result.returnCode == "00") {
        this.recommendList = result.returnData;
        this.setDialogHeightByKeywordItemNumber(this.recommendList);
      }
    },
    async clearAllCurrentData() {
      this.searchingString = "";
      this.clearAllCheckedGender();
      this.inSearching = false;
      this.inSearchingKeyWord = false;
      this.inSearchingProducts = false;
      if (!this.recommendList || this.recommendList.length == 0) {
        await this.getRecommendSearchingList();
      }
    },
    itemClick(item) {
      this.cancelClick();
      this.clearAllCurrentData();
      this.$router.push({
        name: "shopping",
        params: {
          friendly_url: item.friendlyUrl
        }
      });
    },
    clearAllCheckedGender() {
      for (let key in this.genderSelectedList) {
        this.$set(this.genderSelectedList, key, false);
      }
      // this.searchKeyInput();
      this.searchKeyEnter();
    },
    checkGender(item) {
      this.$set(
        this.genderSelectedList,
        item.recommendationTag,
        !this.genderSelectedList[item.recommendationTag]
      );
      // this.searchKeyInput();
      this.searchKeyEnter();
    },
    setDialogHeightFull() {
      let totalHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.dialogHeight = (totalHeight - this.searchDialogMarginTop) / 100;
    },

    setDialogHeightByKeywordItemNumber(list, inSearching = false) {
      if (list.length > 6) {
        this.dialogHeight =
          30.3 + 1.8 * (list.length - 6) + (inSearching ? 8 : 0);
      } else {
        this.dialogHeight = 30.3;
      }
    },

    async searchKeyEnter(type) {
      this.$emit('clearSerchModal','1')
      if(type==1){
        this.hasLogin = window.localStorage.getItem("token") ? false : true;
        if(!this.hasLogin){
          this.$utils.searchLogAdd(this,this.searchingString)
        }else{
          this.$utils.searchLogAdd(this,this.searchingString,1)
        }
       
      }
      
      if (this.searchingString.length > 0) {
        this.gaSearch();
        this.inSearching = true;
        this.inSearchingProducts = true;
        this.inSearchingKeyWord = false;
        let tags = [];
        for(let key in this.genderSelectedList){
          if(this.genderSelectedList[key]){
            tags.push(key);
          }
        }
        let result = await this.$service.searching.searchProductAPart({
          merchantId: this.$store.state.storeId,
          searchKey: this.searchingString.toUpperCase(),
          tagJson:  tags.join(','),
        });
        if (result.returnCode == "00") {
          if (this.$store.state.soldOut == 0) {
            var tempList = [];
            tempList = result.returnData.dtoList.productBases;
            this.searchingProductList = tempList;
          } else {
            this.searchingProductList = result.returnData.dtoList.productBases;
          }
          this.totalSearchNumber = result.returnData.dtoList.productCount;
          this.genderFilterList = result.returnData.tagList;
          this.reLoadImage();
          this.loadImages(0);
          // this.$utils.updateImgOssSuffix(this); //检测是否支持webp格式
          this.gaViewItem();
          // this.searchingResultNumber = result.returnData.productCount;
          this.setDialogHeightFull();
        }
      }
    },

    //view_item的ga埋点
    gaViewItem() {
      if (this.searchingProductList.length != 0) {
        let gaUrl = "";
        gaUrl = "search_fw";
        this.$gaAction.view_item(this.searchingProductList, gaUrl);
      }
    },

    //GA search埋点
    gaSearch() {
      this.$gaAction.search(this.searchingString);
    },

    async searchKeyInput() {
      
      this.inSearchingProducts = false;
      if (this.searchingString.length > 0) {
        this.inSearching = true;
        this.inSearchingKeyWord = true;
        this.inSearchingProducts = false;
        let jsonList = [];
        for (let key in this.genderSelectedList) {
          if (this.genderSelectedList[key]) {
            jsonList.push(key);
          }
        }
        let result = await this.$service.searching.searchKeyWords(
          `?merchantId=${
            this.$store.state.storeId
          }&searchKey=${this.searchingString.toUpperCase()}&tagJson=${encodeURIComponent(
            JSON.stringify(jsonList)
          )}`
        );
        if (result.returnCode == "00") {
          this.searchingKeyWordList = result.returnData;
          this.setDialogHeightByKeywordItemNumber(
            this.searchingKeyWordList,
            true
          );
        }
      } else {
        this.inSearching = false;
        this.setDialogHeightByKeywordItemNumber(this.recommendList);
      }
    },
    searchByKeyword(item) {
      this.hasLogin = window.localStorage.getItem("token") ? false : true;
        if(!this.hasLogin){
          this.$utils.searchLogAdd(this,this.searchingString)
        }else{
          this.$utils.searchLogAdd(this,this.searchingString,1)
        }
      this.$emit('clearSerchModal','1')
      
      if (item.fuLink) {
        this.$router.push({
          name: item.prefixLevelLink,
          params: { friendly_url: item.fuLink }
        });
        this.cancelClick();
        this.clearAllCurrentData();
       
        return;
      }
      if (item.name) {
   
        this.$router.push({
          name: "searchList",
          params: { friendly_url: item.name }
        });
        this.$gaAction.search(item.name);
        this.cancelClick();
        this.clearAllCurrentData();
        return;
      }
      this.$router.push({
        name: "searchList",
        params: { friendly_url: item.searchKey }
      });
      this.$gaAction.search(item.searchKey);
      this.cancelClick();
      this.clearAllCurrentData();
    },

    cancelClick() {
      this.$emit("cancelClick");
    },

    //遮罩层穿透，阻止底部滑动
    moveHandle() {
      return;
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ivu-input {
  background-color: rgba(0, 0, 0, 0) !important;
  border: none !important;
  border-bottom: 0.1rem solid #5c5d5f !important;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  // color: #ffffff;
}
/deep/ .ivu-input::-webkit-input-placeholder {
  color: #5c5d5f;
  font-size: 1.2rem;
  text-transform: uppercase;
  text-align: left;
}
/deep/ .ivu-input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #5c5d5f;
  font-size: 1.2rem;
  text-transform: uppercase;
  text-align: left;
}
/deep/ .ivu-input::-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #5c5d5f;
  font-size: 1.2rem;
  text-transform: uppercase;
  text-align: left;
}
/deep/ .ivu-input::-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #5c5d5f;
  font-size: 1.2rem;
  text-transform: uppercase;
  text-align: left;
}
.search-container {
  .dialog-mb {
    display: none;
  }
  .dialog {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    //top: 10rem;
    background-color: rgba(0, 0, 0, 0.4);

    //&:before {
    //  background-color: transparent;
    //  height: 10.1rem;
    //  content: "";
    //  position: fixed;
    //  top: 0;
    //  right: 0;
    //  left: 0;
    //}
    .dialog-container-in-searching {
      height: 100% !important;
    }
    .dialog-container {
      position: absolute;
      top: 0;
      right: 0;
      left: calc(100% - 55.5rem);
      //min-height: 34.3rem;
      //max-height: calc(100% - 6.6rem);
      padding: 0.3rem 3.5rem 0rem 4rem;
      text-align: center;
      transition: height 0.3s ease-in-out;
      background-color: #fff;
       .iconenter{
          width: 1.6rem;
          height:1.6rem;
          position: absolute;
          top:1.3rem;
          right:3.9rem;
          cursor: pointer;
          img{
            width: 1.6rem;
            height:1.6rem;
            object-fit: cover;
          }
        }
      /deep/ .search-input {
        //padding-bottom: 2.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: url("../../assets/image/icon/search.png") no-repeat;
        background-size: 1.5rem;
        background-position: left center;
        position: relative;
       
        // .ivu-icon-ios-search {
        //   width: 2rem;
        //   height: 2rem;
        //   left: 0;
        //   font-size: 2rem;
        //   font-weight: bold;
        // }
        input {
          border: none;
          border-bottom: 0.1rem solid #5c5d5f;
          padding-left: 2.6rem;
        }
      }
      .recommend-search {
        padding-top: 5rem;
        text-align: left;
        font-size: 1.2rem;
        .recommend-search-title {
        }
        .search-list {
          padding-top: 3.5rem;
          .search-item {
            font-size: 1.2rem;
            font-family: ArialNarrow;
            color: #5c5d5f;
            line-height: 1.2;
            margin-bottom: 0.6rem;
          }
        }
      }

      .search-result-content-box {
        display: flex;
        flex-direction: column;
        height: 100%;
        .search-result-check-box {
          padding-bottom: 3rem;
          padding-top: 3rem;
          display: flex;
          border-bottom: 1px solid #eaeaea;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .my-check-box {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
            -khtml-user-select: none;
            user-select: none;
            .check-box-action-box {
              width: 1.7rem;
              height: 1.7rem;
              border: 1px solid #959595;
            }
            .checkbox-title {
              margin-left: 1.1rem;
              text-align: center;
              line-height: 1.7rem;
              font-size: 1.2rem;
              font-weight: 400;
              color: #5c5d5f;
            }
          }
          .clear-all {
            cursor: pointer;
            text-decoration: underline;
            font-size: 1.2rem;
            min-width: 50px;
            width: 50px;
            text-align: center;
            color: #5c5d5f;
            font-weight: 500;
          }
        }
        .in-searching-product {
          display: flex;
          flex-direction: column;
          height: 0;
          flex-grow: 1;
          .search-result-content-number-box {
            padding-top: 2.2rem;
            padding-bottom: 1.8rem;
            display: flex;
            flex-direction: row;
            .search-result-content-number-title {
              font-size: 1.2rem;
              font-family: ArialNarrow;
              color: #5c5d5f;
            }
            .search-result-content-number-all {
              cursor: pointer;
              font-size: 1.2rem;
              font-weight: 400;
              text-decoration: underline;
              margin-left: auto;
              color: #5c5d5f;
            }
          }
        }
        .in-searching-keyword {
          padding-top: 2.2rem;
          .search-result-keyword-box {
            display: flex;
            flex-direction: row;
            margin-bottom: 1.3rem;
            .search-result-keyword-title {
              font-size: 1.2rem;
              font-weight: 400;
              color: #959595;
            }
            .search-result-keyword-number {
              margin-left: auto;
              font-size: 1.2rem;
              font-family: ArialNarrow;
              color: #5c5d5f;
            }
          }
        }
        .search-result-content {
          display: flex;
          overflow: scroll;
          align-content:flex-start;
          height: 0;
          flex-grow: 1;
          flex-wrap: wrap;
          flex-direction: row;
          padding-bottom: 5.5rem;
          .search-result-content-item {
            display: flex;
            cursor: pointer;
            margin-bottom: 2.9rem;
            //margin-right: 2.7rem;
            height: fit-content;
            width: 33.3%;
            flex-direction: column;
            opacity: 0;
            &.imgloaded {
              opacity: 1;
              transition: opacity 0.3s ease-in-out 0.3s;
            }
            .cover-image {
              margin-bottom: 0.2rem;
              width: 14.1rem;
              object-fit: cover;
              height: 18.8rem;
            }
            .result-title {
              font-size: 1.2rem;
              width: 14.1rem;
              // font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5c5d5f;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .search-result-content-item:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .search-container {
    .dialog {
      display: none;
    }
    .dialog-mb {
      position: fixed;
      width: 100%;
      height: 100%;
      display: block !important;
      //top:-10rem;
      &.headSearchShow{
        background:rgba(0,0,0,.75);
      }
      .search-container-mp {
        width: 100%;
        // height: 100%;
        display: flex;
        flex-direction: column;
        .search-input-box {
          align-items: center;
          // margin-top: 20.6rem;
          display: flex;
          flex-direction: row;
          margin-left: 2rem;
          margin-right: 2rem;
          padding-bottom: 2rem;
          border-bottom: 1px solid white;
          .search-image-icon {
            width: 2.3rem;
            height: 2.3rem;
          }
          .input-content {
            width: 0;
            flex-grow: 1;
            font-size: 1.8rem;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            // color: #ffffff;
            border: 0; // 去除未选中状态边框
            outline: none; // 去除选中状态边框
            background-color: rgba(0, 0, 0, 0); // 透明背景
            text-align: center;
          }
          /deep/.ivu-input {
            color: white;
            font-size: 1.8rem;
            text-align: center;
            border-bottom: none !important;
          }

          /deep/.ivu-input::-webkit-input-placeholder {
            color: white;
            font-size: 1.8rem;
            text-transform: uppercase;
            text-align: center;
          }
          /deep/.ivu-input:-moz-placeholder {
            color: white;
            font-size: 1.8rem;
            text-transform: uppercase;
            text-align: center;
          }
          /deep/.ivu-input:-ms-input-placeholder {
            color: white;
            font-size: 1.8rem;
            text-transform: uppercase;
            text-align: center;
          }
          .search-cancel-icon {
            width: 2rem;
            height: 2rem;
          }
        }
        .check-box-mb {
          display: flex;
          margin-top: 3.5rem;
          flex-direction: row;
          padding: 0 2rem;
          justify-content: space-between;
          /deep/.ivu-checkbox-wrapper {
            margin-right: 0rem;
          }
          /deep/.ivu-checkbox-inner {
            background-color: rgba(0, 0, 0, 0);
          }
          .checkbox-title {
            color: #ffffff;
            margin-left: 1.1rem;
            font-size: 1.2rem;
            margin-right: 0rem !important;
          }
          .my-check-box {
            display: flex;
            .check-box-action-box {
              width: 1.7rem;
              height: 1.7rem;
              border: 1px solid #959595;
            }
            .checkbox-title {
              color: #ffffff;
              margin-left: 0.6rem;
              text-align: center;
              line-height: 1.7rem;
              font-size: 1.2rem;
              font-weight: 400;
            }
          }
        }
        .search-keyword-content-box-mb {
          margin-top: 1.9rem;
          display: flex;
          flex-direction: column;
          .search-keyword-content-item {
            margin-bottom: 1.3rem;
            display: flex;
            padding-left: 1.9rem;
            flex-direction: row;
            font-size: 1.2rem;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #959595;
          }
        }
      }
     .recommend-search-mob{
       width: 100%;
       padding:0 2rem;
       box-sizing: border-box;
       text-align: left;
       .recommend-search-label{
        font-weight: 400;
        color:rgba(255, 255, 255, 0.8);
        font-size: 1.4rem;
        margin-bottom: 1.8rem;
       }
       .search-list{
       .search-item{
          font-size: 1.4rem;
          color:rgba(255,255,255,1);
          line-height: 2.8rem;
          opacity: 1;
          overflow: hidden;
          /*文本不会换行*/
          white-space: nowrap;
          /*当文本溢出包含元素时，以省略号表示超出的文本*/
          text-overflow: ellipsis;
          -webkit-line-clamp:1;
          a{
            color:rgba(255,255,255,1);
          }
        }
      }
     }
    }
  }
}

/deep/.search-modal .ivu-modal-content {
  padding: 4rem;
  margin: auto;
  display: flex;
  color: #5c5d5f;
  background-color: #fff;
  min-height: 34.3rem;
  max-height: calc(100% - 10.1rem);
  padding: 0.3rem 3.5rem 5.5rem 4rem;
  transition: min-height 0.5s ease-in-out;
  background-color: #fff;
}
/deep/.search-modal .ivu-modal-body {
  padding: 0;
  line-height: 1.2;
  width: 100%;
  .search-input {
    padding-bottom: 2.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: url("../../assets/image/icon/search.png") no-repeat;
    // .ivu-icon-ios-search {
    //   width: 2rem;
    //   height: 2rem;
    //   left: 0;
    //   font-size: 2rem;
    //   font-weight: bold;
    // }
    input {
      border: none;
      border-bottom: 0.1rem solid #5c5d5f;
      padding-left: 2.6rem;
    }
  }
  .recommend-search {
    padding-top: 2.5rem;
    text-align: left;
    font-size: 1.2rem;
    .recommend-search-title {
    }
    .search-list {
      padding-top: 3.5rem;
      .search-item {
        padding-bottom: 0.6rem;
      }
    }
  }
}
/deep/.ivu-modal-mask {
  top: 10rem;
  background-color: rgba(0, 0, 0, 0.4);
  &:before {
    background-color: transparent;
    height: 10.1rem;
    content: "";
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
  }
}

/deep/.ivu-modal-wrap {
  top: 10rem;
  left: initial;
  position: fixed;
  .ivu-modal {
    top: 0;
  }
}
/deep/.ivu-input:focus {
  outline: none;
  border: none;
  box-shadow: 0 0 0 2px transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SearchPop.vue